import { AuthService } from "@/services";
import { mapActions } from "vuex";
import * as types from "./../../../store/types";
export default {
  name: "google-auth",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      loading: false,
      rules: {
        required: value =>
          !!value || this.$t("authPage.googleAuthPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    google2faToken() {
      return localStorage.getItem("google2faToken");
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    onSubmit() {
      this.loading = true;
      this.verifyUserGoogle2fa();
    },
    verifyUserGoogle2fa() {
      AuthService.verifyUserGoogle2fa(this.google2faToken, this.otpCode)
        .then(response => {
          localStorage.setItem("accessToken", response.data.data.token);
          this.$cookies.set("accessToken", response.data.data.token);
          localStorage.removeItem("google2faToken");
          localStorage.setItem("isAuth", "true");
          this.checkIsAuth();
          this.$router.push(`/dashboard`);
        })
        .catch(error => {
          if (error.data.code === "google2fa_otp_attempts_exceeded_error") {
            this.$router.push({ name: "loginForm" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
